import { AppShell, Center, Grid } from "@mantine/core";
import PlayGround from "./PlayGround";

export default function PlaygroundMain() {
  return <PlayGround />;
}
